/*************************************************************************************************************/
/***************************** DO NOT ADD Direvtives/Pipes/Components EASILY !!!!! ***************************/
/******************** JUST ADD THOSE WHO ARE USED IN MULTIPLE PLACES LIKE COMMON PIPES ***********************/
/************* IN ORDER TO REDUCE BOILERPLATE AND TAKE ADVANTAGE OF THE standalone PROPERTY ******************/
/*************************************************************************************************************/

import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';

// Services
import { NatToastrService } from '@shared/services/nat-toastr.service';
import { HttpClientService } from '@shared/services/http-client.service';

// AngularMaterial
import { SharedMaterialModule } from '@shared/shared-material.module';

@NgModule({
  declarations: [],
  exports: [
    CommonModule,
    FormsModule,
    NgbModule,
    SharedMaterialModule
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    SharedMaterialModule,
    ToastrModule.forRoot({
      enableHtml: true,
      progressBar: true,
      closeButton: true,
      preventDuplicates: true,
    })],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class InternetSharedModule {
  static forRoot(): ModuleWithProviders<InternetSharedModule> {
    return {
      ngModule: InternetSharedModule,
      providers: [
        NatToastrService,
        HttpClientService
      ],
    };
  }
}
